import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";
import { useQuery } from "convex/react";
import { api } from "@/convex/_generated/api";
import LicensesTable from "@/components/licenses/licenses-table";
import { RequestsCard } from "@/components/licenses/requests-card";

const licensesSearchSchema = z.object({
  page: z.number().optional().default(1),
  search: z.string().optional(),
  status: z.string().optional(),
  edition: z.string().optional(),
  type: z.string().optional(),
});

export const Route = createFileRoute("/_super/super/licenses")({
  validateSearch: licensesSearchSchema,
  component: LicensesPage,
});

function LicensesPage() {
  const searchParams = Route.useSearch();
  const requests = useQuery(api.system.licensing.queries.listLicenseRequests, {
    status: "pending",
  });

  return (
    <div className="space-y-6">
      {requests && requests.length > 0 && <RequestsCard requests={requests} />}
      <LicensesTable
        currentPage={searchParams.page}
        basePath="/super/licenses"
        searchParams={searchParams}
      />
    </div>
  );
}